import { DefaultRecourse, ProcessedEvent, ResourceFields } from '@aldabil/react-scheduler/types';
import placeApi from '@src/services/api/place';
import { RequestBookingScheduleType } from '@src/types/booking';
import dayjs from 'dayjs';
import { useEffect, useMemo, useRef, useState } from 'react';

// event_id: 1,
//   title: "Event 1",
//     start: new Date(new Date(new Date().setHours(9)).setMinutes(0)),
//       end: new Date(new Date(new Date().setHours(10)).setMinutes(0)),
//         disabled: true,
//           admin_id: [1, 2, 3, 4]

const COLORS = [
  '#B37256',
  '#16463F',
  '#EB3C27',
  '#478493',
  '#C34121',
  '#DAB965',
  '#dcad3e',
  '#0b4314',
  '#4c0f0f',
  '#3b63e8',
];
const DISABLE_COLOR = '#b6b6b6';

function parseList(schduleList: RequestBookingScheduleType[], type?: string) {
  const groupKey = type === 'admin' ? 'club_id' : 'request_user_id';
  const groupInfo: { id: number | string; name: string }[] = [{ id: 'all', name: 'All' }];
  let colorIndex = 0;
  const colors: { [key: string]: string } = {};
  const list = schduleList.map(data => {
    if (!colors[data[groupKey]]) {
      colors[data[groupKey]] = COLORS[colorIndex++];
      groupInfo.push({ id: data[groupKey], name: type !== 'admin' ? data.name : data.club_name });
    }
    const response = data.response && JSON.parse(data.response);
    const result = response ? !response.errors : undefined;

    const color = response ? (result === true ? colors[data[groupKey]] : DISABLE_COLOR) : colors[data[groupKey]] + '30';
    return {
      event_id: data.id,
      title: ` ${response ? '완료 ' : '대기 '}${data.business_name} ${data.item_name} 예약자 : ${data.name}, 방문자: ${data.visitor_name} ${type === 'admin' ? `클럽명 : ${data.club_name}` : ''} ${dayjs(data.start_date_time).format('YYYY-MM-DD HH:mm')}~${dayjs(data.end_date_time).format('HH:mm')}`,
      start: new Date(dayjs(data.start_date_time).format('YYYY-MM-DD HH:mm')),
      end: new Date(dayjs(data.end_date_time).format('YYYY-MM-DD HH:mm')),
      color,
      admin_id: ['all', data[groupKey]],
      business_id: data.business_id,
      status: response ? 'AFTER' : 'BEFORE',
    };
  });
  const group = groupInfo.map(({ id, name }) => ({
    admin_id: id,
    title: name,
    sub_title: id ? id : 'all',
    color: colors[id] || '#2a2a2a',
  }));
  return { list, colors, group };
}

export default function useBookingSchedule(
  date: Date,
  filterPlace?: string,
  status?: 'AFTER' | 'BEFORE',
  type?: string,
) {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<ProcessedEvent[]>([]);
  const [resource, setResource] = useState<DefaultRecourse[]>([]);
  const [colors, setColors] = useState<{ [key: string]: string }>({});

  const filteredList = useMemo(() => {
    return !status && !filterPlace
      ? list
      : list.filter(data => {
          if (status && filterPlace) {
            return status === data.status && filterPlace === data.business_id;
          } else if (status && !filterPlace) {
            return status === data.status;
          } else if (!status && filterPlace) {
            return filterPlace === data.business_id;
          }
        });
  }, [status, filterPlace, list]);
  const getScheduleList = async () => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const { data } = await placeApi.getClubSchdule(year, month);
    const { colors, list, group } = parseList(data, type);

    setList(list);
    setColors(colors);
    setResource(group);
    setLoading(false);
  };

  useEffect(() => {
    getScheduleList();
  }, [date, type]);

  return { list: filteredList, loading, colors, resource };
}
